import React, { useState } from "react";

const ServiceAddedValueSection = ({
	title = "title",
	secondaryTitle = "secondaryTitle",
	serviceTabs = [],
	translations,
}) => {
	const [activeTab, setActiveTab] = useState(serviceTabs[0]);

	return (
		<section className="flex flex-col gap-8 z-50">
			<div className="flex flex-col self-start gap-8">
				<div className="flex flex-col">
					<h4 className="text-ipxon-magenta font-normal text-lg">
						{translations[secondaryTitle]}
					</h4>
					<h2 className="text-2xl md:text-3xl font-normal text-ipxon-black w-full leading-tight">
						{translations[title]}
					</h2>
				</div>
			</div>
			<div className="w-full">
				<div className="grid grid-cols-2 md:flex md:gap-4 2xl:gap-6 w-full md:border-b md:border-neutral-400 justify-between">
					{serviceTabs.map((tab, index) => (
						<button
							key={index}
							onClick={() => setActiveTab(tab)}
							className={`py-4 text-left justify-center text-sm hover:text-[#DD097D] border-b border-neutral-400 md:border-b-0 ${
								activeTab && activeTab.title === tab.title
									? "text-ipxon-magenta"
									: "text-ipxon-black"
							}`}
						>
							{translations[tab.title]}
						</button>
					))}
				</div>
				{activeTab && (
					<div className="mt-4">
						<h5 className="mt-12 text-xl md:text-2xl font-bold text-ipxon-black">
							{translations[activeTab.title]}
						</h5>
						<p className="mt-5 text-base w-full min-h-[72px] text-ipxon-medium-dark-gray">
							{translations[activeTab.content]}
						</p>
					</div>
				)}
			</div>
		</section>
	);
};

export default ServiceAddedValueSection;
